import chalk from "chalk"
import { format } from "date-fns"
import type { Logger } from "../types/types.js"

class LoggerImpl implements Logger {
  private debugMode = false
  private silent = false

  setDebugMode(enabled: boolean): void {
    this.debugMode = enabled
  }

  setSilent(enabled: boolean): void {
    this.silent = enabled
  }

  info(message: string): void {
    if (!this.silent) {
      console.log(chalk.blue("ℹ"), message)
    }
  }

  success(message: string): void {
    if (!this.silent) {
      console.log(chalk.green("✔"), message)
    }
  }

  warning(message: string): void {
    if (!this.silent) {
      console.log(chalk.yellow("⚠"), message)
    }
  }

  error(message: string): void {
    console.error(chalk.red("✖"), message)
  }

  debug(message: string): void {
    if (this.debugMode && !this.silent) {
      const timestamp = format(new Date(), "HH:mm:ss.SSS")
      console.log(chalk.gray(`[${timestamp}]`), chalk.dim(message))
    }
  }

  box(title: string, content: Array<string>): void {
    if (this.silent) return

    const maxLength = Math.max(
      title.length,
      ...content.map((line) => line.length),
    )
    const boxWidth = maxLength + 4

    console.log(chalk.cyan(`┌${"─".repeat(boxWidth - 2)}┐`))
    console.log(
      `${chalk.cyan("│")}${chalk.bold(` ${title.padEnd(boxWidth - 4)} `)}${chalk.cyan("│")}`,
    )
    console.log(chalk.cyan(`├${"─".repeat(boxWidth - 2)}┤`))

    for (const line of content) {
      console.log(
        `${chalk.cyan("│")} ${line.padEnd(boxWidth - 4)} ${chalk.cyan("│")}`,
      )
    }

    console.log(chalk.cyan(`└${"─".repeat(boxWidth - 2)}┘`))
  }

  table(data: Array<[string, string]>): void {
    if (this.silent) return

    const maxKeyLength = Math.max(...data.map(([key]) => key.length))

    for (const [key, value] of data) {
      console.log(
        `  ${chalk.gray(key.padEnd(maxKeyLength + 2))} ${chalk.white(value)}`,
      )
    }
  }

  divider(): void {
    if (!this.silent) {
      console.log(chalk.gray("─".repeat(50)))
    }
  }

  newLine(): void {
    if (!this.silent) {
      console.log("")
    }
  }
}

export const logger = new LoggerImpl()
